import { logAndylitics, log, logAPI } from "./andyliticsApi";
import * as tools from "../helpers/Tools";

const BASE_URL = window.serverData.data.membershipBffUrl;

/**
* setMembershipNotificationResponse
* @param {string} token = token
* @param {string} data = { "response":[string], "id":[string]}
* @returns {Promise} success/failure
 */
export const setMembershipNotificationResponse = (token, data) => {
    const fullUrl = `${BASE_URL}api/v1/notification/response`;

    const params = {
        headers: {
            authorization: `bearer ${token}`
        },
        body: JSON.stringify(data),
        method: "PUT"
    };

    const start = new Date();

    return fetch(fullUrl, params).then(response => {
        logAPI("MBHWeb.Api.Membership.SetMembershipNotiResponse.Post", start, fullUrl);
        return response;
    }).catch(err => {
        logAPI("MBHWeb.Api.Membership.SetMembershipNotiResponse.Post.Failure", start, fullUrl);
        return Promise.reject(err);
    });
};
